/**
 * Unisce testi tradotti e valori con uno spazio, togliendo quelli ai bordi di ogni pezzo.
 * Nei JSON delle traduzioni gli spazi ai bordi non sono affidabili (alcune lingue li hanno, altre no):
 * "Dopo le ore " + 11 + "e' possibile" darebbe "Dopo le ore 11e' possibile".
 */
export function unisciTesti(...parti: Array<string | number | null | undefined>): string {
  return parti.map(parte => String(parte ?? '').trim()).filter(parte => parte !== '').join(' ');
}
